import { useEffect, useState } from 'react';

import { ObservableAndState } from '../utils/observable_and_state';

export const useObservableAndState = <T>(observableAndState: ObservableAndState<T>) => {
  const { state, observable } = observableAndState;
  const [data, setData] = useState(state ?? null);

  useEffect(() => {
    const subscription = observable.subscribe(setData);
    return () => subscription.unsubscribe();
  }, [observable]);

  return data as T;
};
